import { connect } from 'react-redux';
import { withRouter } from 'utils/withRouter';
import MentoringCard from '../components';

const mapStateToProps = state => ({
  literals: state.i18n.literals.mentoringCard,
});

export default withRouter(connect(mapStateToProps)(MentoringCard));
